import React from 'react';
import classNames from 'classnames';
import './index.scss';
import { CommonProps } from 'src/components/helpers/props';

export interface IProps extends CommonProps {
  size?: 'md' | 'sm' | 'lg';
  fill?: string;
}

const RequestIcon: React.FC<IProps> = ({ classes, size = 'md', fill }) => {
  return (
    <svg
      className={classNames('icon-root', classes)}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      color="#B5BBC2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.866699 10C0.866699 4.95583 4.95583 0.866699 10 0.866699C15.0442 0.866699 19.1334 4.95583 19.1334 10C19.1334 15.0442 15.0442 19.1334 10 19.1334C4.95583 19.1334 0.866699 15.0442 0.866699 10ZM9.99995 5.8667C10.4418 5.8667 10.8 6.22487 10.8 6.6667V9.19995H13.3334C13.7752 9.19995 14.1334 9.55812 14.1334 9.99995C14.1334 10.4418 13.7752 10.8 13.3334 10.8H10.8V13.3334C10.8 13.7752 10.4418 14.1334 9.99995 14.1334C9.55812 14.1334 9.19995 13.7752 9.19995 13.3334V10.8H6.6667C6.22487 10.8 5.8667 10.4418 5.8667 9.99995C5.8667 9.55812 6.22487 9.19995 6.6667 9.19995H9.19995V6.6667C9.19995 6.22487 9.55812 5.8667 9.99995 5.8667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RequestIcon;
